import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { accessLocalStorage, readAllTenant } from '../../../services';

import PbxContext from '../../../context/PbxContext';
import '../../../libs/bulma.min.css';
import './TenantsList.css';

import Loading from '../../../components/Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash, faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';

function TenantsList() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsChangeFormElements, toggleIsHidden, setItemsSelectedToEdit } = getItensStateGlobal;

  const [loading, setLoading] = useState(true);
  const [tenants, setTenants] = useState([]);
  const [tenantsSelected, setTenantsSelected] = useState([]);
  const [disable, setDisable] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');
  const [filterText, setFilterText] = useState('');

  const history = useHistory();

  const convertForDateBr = (dateReceived) => {
    const date = new Date(dateReceived);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();

    const dateBr = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
    const time = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}`;

    return `${dateBr} ${time}`;
  };

  const handleSort = (columnKey) => {
    let direction = 'asc';
    
    if (sortColumn === columnKey && sortDirection === 'asc') {
      direction = 'desc';
    }
    
    setSortColumn(columnKey);
    setSortDirection(direction);
    
    const sortedTenants = [...tenants].sort((a, b) => {
      let aValue, bValue;
      
      switch (columnKey) {
        case 'name':
          aValue = a.name.toLowerCase();
          bValue = b.name.toLowerCase();
          break;
        case 'short_name':
          aValue = a.short_name.toLowerCase();
          bValue = b.short_name.toLowerCase();
          break;
        case 'rec_time':
          aValue = parseInt(a.rec_time) || 0;
          bValue = parseInt(b.rec_time) || 0;
          break;
        case 'endpoints_count':
          aValue = a.endpoints.filter((item) => !isNaN(Number(item.endpoint))).length;
          bValue = b.endpoints.filter((item) => !isNaN(Number(item.endpoint))).length;
          break;
        case 'active':
          aValue = a.active ? 1 : 0;
          bValue = b.active ? 1 : 0;
          break;
        case 'created_at':
          aValue = new Date(a.created_at).getTime();
          bValue = new Date(b.created_at).getTime();
          break;
        default:
          return 0;
      }
      
      if (aValue < bValue) return direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return direction === 'asc' ? 1 : -1;
      return 0;
    });
    
    setTenants(sortedTenants);
  };

  const getSortIcon = (columnKey) => {
    if (sortColumn !== columnKey) {
      return <FontAwesomeIcon icon={faSort} className="sort-icon" />;
    }
    return sortDirection === 'asc' 
      ? <FontAwesomeIcon icon={faSortUp} className="sort-icon active" />
      : <FontAwesomeIcon icon={faSortDown} className="sort-icon active" />;
  };

  const filteredTenants = tenants.filter((tenant) => {
    const searchText = filterText.toLowerCase();
    return (
      tenant.name.toLowerCase().includes(searchText) ||
      tenant.short_name.toLowerCase().includes(searchText) ||
      tenant.rec_time.toString().includes(searchText) ||
      tenant.endpoints.some((ep) => ep.endpoint.toLowerCase().includes(searchText))
    );
  });

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    if (!dataUser) {
      history.push('/');
      // return;
    }

    const { user: { role, idtenant } } = dataUser;
    if (role !== 'root') {
      history.push('/home');
      return;
    }

    setIsAuthorized(true);
    let tenantsFetched = await readAllTenant();
    tenantsFetched = idtenant.includes('vgs') ? tenantsFetched : tenantsFetched.filter((tenant) => idtenant.includes(tenant.short_name));
    
    if (tenantsFetched) {
      setTenants(tenantsFetched);
      setLoading(false);
    }
  }, [history]);

  const handleChangeSelectedTenants = (element) => {
    setTenantsSelected((prevState) => {
      const onlineState = prevState.includes(element) ? [...prevState.filter((e) => e !== element)] : [...prevState, element];
      setDisable(onlineState.length === 0);
      return onlineState;
    });
  };

  const handleClickDelete = async () => {
    return;
  };

  const handleClickUpdate = async () => {
    setItemsSelectedToEdit(tenantsSelected);
    return history.push('/config/cliente/id');
  };

  const handleChangeSelectAll = () => {
    const inputSelectAll = document.getElementById('select-all');
    const selectTenants = tenants.map((element) => {
      const getCheckbox = document.getElementById(element.short_name);
      if(inputSelectAll.checked) {
        getCheckbox.checked = true;
        setDisable(false);
        return element.endpoint;
      } else {
        getCheckbox.checked = false;
        setDisable(true);
        return null;
      }
    });
    const result = selectTenants[0] === null ? [] : selectTenants;
    return setTenantsSelected(result);
  };

  const changeTenant = (tenant) => {
    const user = accessLocalStorage.getUserLocalStorage();
    if (user) {
      accessLocalStorage.removeUserItem();
      user.user.idtenant = tenant;
      accessLocalStorage.setUserLocalStorage(user);
      history.push('/dashboard');
      // if (user.user.role === 'root') {
      //   toggleIsChangeFormElements('config-items', 'navbar-dropdown mx-0 px-0 has-text-centered is-active');
      //   toggleIsChangeFormElements('troubleshooting-items', 'navbar-dropdown is-active');
      // }
      return window.location.reload();
    }
  };

  useEffect(() => {
    let cancel = false;
    if (!cancel) {
      validateUserLogged();
    }
    return () => {
      cancel = true;
    };
  }, [validateUserLogged]);

  if (!isAuthorized) {
    return null;
  }

  return (
    <div className="tenants-list-container">
      {
        loading ?
          <Loading />
        :
        <div className="tenants-content">
          <div className="tenants-header">
            <div className="tenants-title-wrapper">
              <svg className="tenants-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              <h1 className="tenants-title">Lista de Clientes</h1>
              <p className="tenants-subtitle">Gerenciamento de tenants do sistema</p>
            </div>
          </div>
          <div className="alerts-section">
            <article id="alert-tenants-not-delete" name="alert-tenants-not-delete" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <p>Atenção!</p>
                <button className="alert-close" aria-label="delete" onClick={ () => toggleIsHidden('#alert-tenants-not-delete') }></button>
              </div>
              <div className="alert-body">
                Não foi possível deletar os clientes selecionados.
              </div>
            </article>
            <article id="alert-confirm-tenants-delete" name="alert-confirm-tenants-delete" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <p>Atenção!</p>
                <button className="alert-close" aria-label="delete" onClick={ () => toggleIsHidden('#alert-confirm-tenants-delete') }></button>
              </div>
              <div className="alert-body">
                Tem certeza que quer deletar os clientes selecionados?
              </div>
              <div className="alert-actions">
                <button className="btn-alert btn-danger" type="submit" onClick={ () => handleClickDelete() }>
                  <FontAwesomeIcon icon={ faTrash } fixedWidth />
                  <span>Confirmar</span>
                </button>
                <button className="btn-alert btn-info" type="submit" onClick={ () => {
                  toggleIsHidden('#alert-confirm-tenants-delete')
                  toggleIsHidden('#buttons')
                }}>
                  <span>Cancelar</span>
                </button>
              </div>
            </article>
            <article id="alert-create-tenants" name="alert-create-tenants" className="alert-message alert-success is-hidden">
              <div className="alert-header">
                <p>Sucesso!</p>
                <button className="alert-close" aria-label="delete" onClick={ () => toggleIsHidden('#alert-create-tenants') }></button>
              </div>
              <div className="alert-body">
                Clientes deletados com sucesso!
              </div>
            </article>
          </div>

          <div className="filter-section">
            <div className="filter-input-wrapper">
              <svg className="filter-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input
                type="text"
                className="filter-input"
                placeholder="Filtrar por nome, ID, tempo de gravação ou operadora..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
              {filterText && (
                <button className="filter-clear" onClick={() => setFilterText('')}>
                  ×
                </button>
              )}
            </div>
            <div className="filter-results">
              Exibindo {filteredTenants.length} de {tenants.length} cliente(s)
            </div>
          </div>
          
          <div className="tenants-table-wrapper">
            <table className="tenants-table">
              <thead className="tenants-table-header">
                <tr>
                  <th 
                    className={`sortable-header ${sortColumn === 'name' ? 'active' : ''}`}
                    onClick={() => handleSort('name')}
                  >
                    Nome {getSortIcon('name')}
                  </th>
                  <th 
                    className={`sortable-header ${sortColumn === 'short_name' ? 'active' : ''}`}
                    onClick={() => handleSort('short_name')}
                  >
                    ID/Feixe {getSortIcon('short_name')}
                  </th>
                  <th 
                    className={`sortable-header ${sortColumn === 'rec_time' ? 'active' : ''}`}
                    onClick={() => handleSort('rec_time')}
                  >
                    Tempo de Gravação {getSortIcon('rec_time')}
                  </th>
                  <th 
                    className={`sortable-header ${sortColumn === 'endpoints_count' ? 'active' : ''}`}
                    onClick={() => handleSort('endpoints_count')}
                  >
                    Ramais {getSortIcon('endpoints_count')}
                  </th>
                  <th>Operadora</th>
                  <th 
                    className={`sortable-header ${sortColumn === 'active' ? 'active' : ''}`}
                    onClick={() => handleSort('active')}
                  >
                    Status {getSortIcon('active')}
                  </th>
                  <th 
                    className={`sortable-header ${sortColumn === 'created_at' ? 'active' : ''}`}
                    onClick={() => handleSort('created_at')}
                  >
                    Desde {getSortIcon('created_at')}
                  </th>
                  <th className="th-actions">Ações</th>
                </tr>
              </thead>
              <tbody>
              {
                filteredTenants.map((tenant) => {
                  const { name, short_name, active, endpoints, rec_time, created_at } = tenant;
                  return (
                    <tr key={ short_name }>
                      <td className="td-name">{name}</td>
                      <td>{short_name}</td>
                      <td>{rec_time}</td>
                      <td>{endpoints.filter((item) => !isNaN(Number(item.endpoint))).length}</td>
                      <td>{endpoints.map((item) => item.endpoint).filter((item) => isNaN(Number(item)))}</td>
                      <td>
                        <span className={`status-badge ${active ? 'status-active' : 'status-inactive'}`}>
                          {active ? 'Ativo' : 'Desativado' }
                        </span>
                      </td>
                      <td className="td-date">{convertForDateBr(created_at)}</td>
                      <td className="td-actions">
                        <button className="btn-access" onClick={ () => changeTenant(short_name) }>
                          <svg className="btn-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                          </svg>
                          <span>Acessar</span>
                        </button>
                      </td>
                    </tr>)
                })
              }
              </tbody>
            </table>
          </div>
          
          <div id="buttons" className="tenants-actions">
            <button
              className="btn-tenant-action btn-edit-tenant" type="submit" onClick={ () => handleClickUpdate() } disabled={ true }>
              <FontAwesomeIcon icon={ faPen } fixedWidth />
              <span>Alterar</span>
            </button>
            <button
              className="btn-tenant-action btn-delete-tenant"
              type="submit"
              onClick={ () => {
                toggleIsHidden('#alert-confirm-tenants-delete')
                toggleIsHidden('#buttons')
              }}
              disabled={ true }
            >
              <FontAwesomeIcon icon={ faTrash } fixedWidth />
              <span>Deletar</span>
            </button>
          </div>
        </div>
      }
    </div>
  );
}

export default TenantsList;